import { gql } from '@apollo/client';

export const createBalancingPointAssetMutation = gql`
  mutation CreateBalancingPointAsset($creation: EkaBalancingPointCreation!) {
    ekaCreateBalancingPoint(creation: $creation) {
      ... on Asset {
        id
        name
        attributeValues {
          id
          value
          attributeType {
            id
            name
          }
        }
      }
      ... on EkaBalancingPointCreationError {
        errors {
          __typename
          errorCode
          message
        }
      }
      ... on AccessDeniedError {
        __typename
        errorCode
      }
    }
  }
`;
